import { createAction } from 'redux-actions';

export const setWebSocketQCSReadyState = createAction('SET_WEBSOCKET_QCS_READY_STATE');
export const sendWebSocketQCSMessage = createAction('SEND_WEBSOCKET_QCS_MESSAGE');
export const getWebSocketQCSMessage = createAction('GET_WEBSOCKET_QCS_MESSAGE');
